import propTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';

const sidebarNavItems = [
  {
    display: 'Dashboard',
    icon: <i className='fa-light fa-star'></i>,
    to: '',
    section: 'main'
  },
  {
    display: 'Guests',
    icon: <i className='fa-light fa-user'></i>,
    to: 'guests',
    section: 'guests'
  },
  {
      display: 'Bookings',
      icon: <i className='fa-light fa-receipt'></i>,
      to: 'booking',
      section: 'booking'
  },
  {
      display: 'Rooms',
      icon: <i className='fa-light fa-bed'></i>,
      to: 'room',
      section: 'room'
  },
  {
    display: 'Bar',
    icon: <i className='fa-light fa-wine-glass-empty'></i>,
    to: 'bar',
    section: 'bar'
  },
  {
    display: 'Banquet Hall',
    icon: <i className='fa-light fa-ring-diamond'></i>,
    to: 'banquethall',
    section: 'banquethall'
  },
  {
    display: 'Conference Hall',
    icon: <i className='fa-light fa-podium'></i>,
    to: 'conference',
    section: 'conference'
  },
  {
    display: 'Coupons',
    icon: <i className='fa-light fa-sticky-note'></i>,
    to: 'coupons',
    section: 'coupons'
  },
  {
    display: 'Payments',
    icon: <i className='fa-light fa-indian-rupee'></i>,
    to: 'payments',
    section: 'payments'
  },
  {
    display: 'Gallery',
    icon: <i className='fa-light fa-images'></i>,
    to: 'gallery',
    section: 'gallery'
  },
  {
    display: 'Feedbacks',
    icon: <i className='fa-light fa-comments'></i>,
    to: 'feedbacks',
    section: 'feedbacks'
  },
]

const Sidebar = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sidebarRef = useRef();
  const location = useLocation();

  // change active index
  useEffect(() => {
      const curPath = window.location.pathname.split('/')[2] ? window.location.pathname.split('/')[2] : 'main';
      const activeItem = sidebarNavItems.findIndex(item => item.section === curPath);
      setActiveIndex(curPath.length === 0 ? 0 : activeItem);
  }, [location]);

  return (
  <div className='sidebar'>
      <div className="sidebar__logo"></div>
      <div ref={sidebarRef} className="sidebar__menu">
          {
            sidebarNavItems.map((item, index) => (
              <Link to={item.to} key={index}>
                  <div className={`${activeIndex === index ? 'sidebar__menu__item__active' : 'sidebar__menu__item'}`}>
                      <div className="sidebar__menu__item__icon">
                          {item.icon}
                      </div>
                      <div className="sidebar__menu__item__text">
                          {item.display}
                      </div>
                  </div>
              </Link>
            ))
          }
      </div>
      {/* <div className='sidebar__footer'>
        Clock Space
      </div> */}
  </div>
)};


const AdminDashboard = () => {
  return (
    <div className='row'>
      <div className='col' style={{ maxWidth: "210px" }}>
        <Sidebar />
      </div>
      <div className='col'>
        <Outlet />
      </div>
    </div>
  )
}

AdminDashboard.propTypes = {
  auth: propTypes.object.isRequired
};


const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(AdminDashboard);